// Label dimensions are stored in mm; customers in the US size labels in inches.
export type Unit = 'mm' | 'in'
export const MM_PER_IN = 25.4
export const toMm = (v: number, unit: Unit): number => (unit === 'in' ? v * MM_PER_IN : v)
export const fromMm = (mm: number, unit: Unit): number => (unit === 'in' ? mm / MM_PER_IN : mm)
export const fmtUnit = (mm: number, unit: Unit): string => (unit === 'in' ? (mm / MM_PER_IN).toFixed(3).replace(/0+$/, '').replace(/\.$/, '') : String(Math.round(mm * 100) / 100))
/** "89 × 28 mm (3.5 × 1.1 in)" */
export const fmtBoth = (wMm: number, hMm: number): string => `${fmtUnit(wMm, 'mm')} × ${fmtUnit(hMm, 'mm')} mm (${(wMm / MM_PER_IN).toFixed(2)} × ${(hMm / MM_PER_IN).toFixed(2)} in)`
/** Custom size name in the unit the user typed. */
export const customName = (wMm: number, hMm: number, unit: Unit): string => `Custom ${fmtUnit(wMm, unit)}×${fmtUnit(hMm, unit)} ${unit}`
